<script setup>
import { defineProps, onMounted, ref } from 'vue';
import OfSessionContactInformation from '@dk.onlinefundraising/onboarding-utils/src/components/OfSessionContactInformation.vue';
import OfProductSelection from '@dk.onlinefundraising/onboarding-utils/src/components/OfProductSelection.vue';
import { toaster } from '@dk.onlinefundraising/vue-utils/src/helpers/OfToaster';
import { user } from '@/store';
import { filterContactData, validateContactData, filterMetaData, filterServiceType, filterTransactionalData, filterCompletionChannel, filterFormResult, filterFormFields, filterQueryString, filterTemporaryServiceType, filterValidateGatewayRequirements, getBetalingsserviceStartDateService } from '@dk.onlinefundraising/onboarding-utils/src/functions';
import requests from '@/OfOnboardingRequests';

const props = defineProps({
    workflow: Object,
    campaign: Object,
    client: Object
})

const product = ref({})
const requestResponse = ref()
const sessionDelayCounter = ref(0);
const sessionStatus = ref();
const iframeGatewayUrl = ref();
const onlyButton = ref();
const sessionCount = ref(0);
// const subscriptionGuid = ref();

const contactDataFields = ref(props.workflow.contactDataFields);

const workflowMetaDataFields = props.workflow.metaDataFields ?? []
const campaignMetaDataFields = props.campaign.metaDataFields ?? []

const metaDataFields = ref(workflowMetaDataFields.concat(campaignMetaDataFields));

let interval;

function initialiseSignup() {

    //  Ensure session delay counter is enforced
    if (sessionDelayCounter.value > 0/* && !ignoreDelay*/) {

        toaster.error("Please wait one moment and try again.");
        return;
    } else {
        sessionDelayCounter.value = 10;

        interval = setInterval(() => {
            sessionDelayCounter.value = sessionDelayCounter.value - 1;

            if (sessionDelayCounter.value == 0) {
                clearInterval(interval);
            }
        }, 1000)

    }

    requestResponse.value = null;

    //  Build request core
    let request = {
        agencyId: user.value.agencyId,
        merchantId: props.client.merchantId,
        agreementData: {},
        subscriptionData: {},
        paymentMethodData: {},
        userGuid: user.value.guid,
        campaignGuid: props.campaign.campaignGuid,
        workflowGuid: props.workflow.workflowGuid,
        serviceType: "",
        externalLeadId: new URLSearchParams(window.location.search).get('externalLeadId'),
        completionChannel: ""
    };

    const productData = { ...product.value };

    request = filterContactData(request, productData, contactDataFields.value, null);
    request = validateContactData(request, contactDataFields.value);
    request = filterMetaData(request, metaDataFields.value);

    request = filterServiceType(request, productData, 'SignUp');
    request = filterCompletionChannel(request, productData);
    // request = filterLeadId(request, productData);

    request = filterTransactionalData(request, productData, props.client);
    request = filterFormResult(request, productData, contactDataFields.value, user.value, props.client, null, props.workflow);
    request = filterFormFields(request);
    request = filterQueryString(request);
    request = filterTemporaryServiceType(request);
    request = filterValidateGatewayRequirements(request, props.client, request.contactData.msisdn ?? productData.msisdn);


    if (request.error) {
        toaster.error(request.error)
        return;
    }

    sessionStatus.value = 'Processing';

    requests.createAgreement(request).then(result => {
        if (result) {
            sessionCount.value++
            // TODO Handle other completion channels
            if (request.completionChannel == 'DataSet') {
                sessionStatus.value = 'Complete';

                requestResponse.value = {
                    message: 'Session complete, please proceed to the next lead',
                    color: 'green'
                }
            } else if (request.completionChannel == 'SMS') {
                loadOnboardingSession(result.sessionGuid)
            } else {
                loadPaymentSession(result.sessionGuid);
            }
        } else {
            sessionStatus.value = 'Error';
        }

    });

}
let sessionInterval;
function loadPaymentSession(sessionGuid) {

    setTimeout(() => {
        getPaymentSession(sessionGuid);
        sessionInterval = setInterval(() => {
            getPaymentSession(sessionGuid);
        }, 3000)
    }, 500)

}
async function getPaymentSession(sessionGuid) {
    requests.getPaymentSession(sessionGuid, props.campaign.merchantId).then(session => {
        if (session){

            if (session.state == 'Failed') {
                requestResponse.value = {
                    message: 'Session failed to start.',
                    color: 'red'
                }
            }
            if (!iframeGatewayUrl.value) {
                iframeGatewayUrl.value = session.redirectToGatewayUrl;
            }

            if (session.state == 'Complete') {
                clearInterval(sessionInterval);
                requestResponse.value = {
                    message: 'Session complete, please proceed to the next lead',
                    color: 'green'
                }
            } else if (session.state == 'Rejected') {
                clearInterval(sessionInterval);
                requestResponse.value = {
                    message: 'Session rejected by lead',
                    color: 'red'
                }
            } else if (session.state == 'Failed') {
                clearInterval(sessionInterval);
                requestResponse.value = {
                    message: 'Session failed by gateway',
                    color: 'red'
                }
            }
        }

        sessionStatus.value = session.state;
    });
}
function loadOnboardingSession(sessionGuid) {
    
    setTimeout(() => {
        getOnboardingSession(sessionGuid);
        sessionInterval = setInterval(() => {
            getOnboardingSession(sessionGuid);
        }, 3000)
    }, 500)

}
function getOnboardingSession(sessionGuid) {
    requests.getOnboardingSession(sessionGuid).then((session) => {
        sessionStatus.value = session.status;

        if (session.status == 'Completed') {
            clearInterval(sessionInterval);
            requestResponse.value = {
                message: 'Session complete, please proceed to the next lead',
                color: 'green'
            }
        } 
    })
}
function abortSession() {
    sessionStatus.value = null;
    requestResponse.value = null;
    iframeGatewayUrl.value = null;
    toaster.success('Aborted');
    clearInterval(sessionInterval);
}
onMounted(() => {

    getBetalingsserviceStartDateService();

    const onlyButtonParam = new URLSearchParams(window.location.search).get('onlyButton');
    onlyButton.value = onlyButtonParam == 'true' ? true : false;
})
</script>
<template>
    <form id="session-form" class="form-horizontal">

        <OfSessionContactInformation v-model:contactDataFields="contactDataFields"
            v-model:metaDataFields="metaDataFields" :workflow="workflow" :only-button="onlyButton"
            :merchant="client" />

        <OfProductSelection v-model="product" :sign-up-products="workflow.signUpProducts" :workflow="workflow"
            :session-delay-counter="sessionDelayCounter" :request-response="requestResponse"
            :iframe-gateway-url="iframeGatewayUrl" :session-status="sessionStatus" :only-button="onlyButton" :merchant="client" 
            @initialise-signup="initialiseSignup" @abort-session="abortSession" :session-count="sessionCount"/>

    </form>
</template>
<style scoped>
form :deep(.message) {
    justify-content: center;
}

form :deep(.message i) {
    display: none;
}
</style>